module.exports = __webpack_public_path__ + "img/图5.9e44e961.png";